module.exports = __webpack_public_path__ + "img/horizontal_7_2_8017.1930fb63.png";